module.exports = __webpack_public_path__ + "static/img/home_act.6e591d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/home_act.png
// module id = v7nT
// module chunks = 1